import { render, staticRenderFns } from "./prices.vue?vue&type=template&id=37fcc240&scoped=true"
import script from "./prices.vue?vue&type=script&lang=js"
export * from "./prices.vue?vue&type=script&lang=js"
import style0 from "./prices.vue?vue&type=style&index=0&id=37fcc240&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcc240",
  null
  
)

export default component.exports